export type LoadingStatus = 'initial' | 'loading' | 'success' | 'failed';

export interface TwilioError {
  code: number;
  message: string;
  moreInfo: string;
}

export interface TwilioErrors {
  [key: number]: TwilioError;
}

export const twilioSmsErrorMap: TwilioErrors = {
  20003: {
    code: 20003,
    message: 'Account not active',
    moreInfo: 'https://www.twilio.com/docs/errors/20003',
  },
  20005: {
    code: 20005,
    message: 'Account suspended',
    moreInfo: 'https://www.twilio.com/docs/errors/20005',
  },
  20006: {
    code: 20006,
    message: 'Account not found',
    moreInfo: 'https://www.twilio.com/docs/errors/20006',
  },
  20008: {
    code: 20008,
    message: 'Account is not authorized to send messages',
    moreInfo: 'https://www.twilio.com/docs/errors/20008',
  },
  21211: {
    code: 21211,
    message: 'Invalid phone number',
    moreInfo: 'https://www.twilio.com/docs/errors/21211',
  },
  21610: {
    code: 21610,
    message: 'Invalid media URL',
    moreInfo: 'https://www.twilio.com/docs/errors/21610',
  },
  21614: {
    code: 21614,
    message: 'Message body is required',
    moreInfo: 'https://www.twilio.com/docs/errors/21614',
  },
  21617: {
    code: 21617,
    message: 'Message is too long',
    moreInfo: 'https://www.twilio.com/docs/errors/21617',
  },
  30034: {
    code: 30034,
    message: 'The phone number you are trying to reach is not valid.',
    moreInfo: 'https://www.twilio.com/docs/errors/30034',
  },
  11200: {
    code: 11200,
    message:
      'Our telephone service is not responding to our request to send this message. Please try again later.',
    moreInfo: 'https://www.twilio.com/docs/errors/11200',
  },
  11751: {
    code: 11751,
    message:
      'The attachment sent with this message is too large. Please try again with a smaller attachment.',
    moreInfo: 'https://www.twilio.com/docs/errors/11751',
  },
  12300: {
    code: 12300,
    message: 'Invalid message content.',
    moreInfo: 'https://www.twilio.com/docs/errors/12300',
  },
  30003: {
    code: 30003,
    message:
      'The device you are trying to reach is switched off or out of coverage range.',
    moreInfo: 'https://www.twilio.com/docs/errors/30003',
  },
  30005: {
    code: 30005,
    message:
      'The destination you are trying to reach is unknown and may no longer exist.',
    moreInfo: 'https://www.twilio.com/docs/errors/30005',
  },
  30006: {
    code: 30006,
    message:
      'The destination you are trying is a landline and does not support SMS.',
    moreInfo: 'https://www.twilio.com/docs/errors/30006',
  },
  30007: {
    code: 30007,
    message: 'Your message was blocked by our telephone service provider.',
    moreInfo: 'https://www.twilio.com/docs/errors/30007',
  },
  30008: {
    code: 30008,
    message: 'Unknown error.',
    moreInfo: 'https://www.twilio.com/docs/errors/30008',
  },
  30019: {
    code: 30019,
    message: 'The size of the message you are trying to send is too large.',
    moreInfo: 'https://www.twilio.com/docs/errors/30019',
  },
  30032: {
    code: 30032,
    message:
      'The Toll Free number you are trying to use has not been verified.  Please contact support for assistance.',
    moreInfo: 'https://www.twilio.com/docs/errors/30032',
  },
  60005: {
    code: 60005,
    message:
      'There as an error with the carrier service of the recipient. Please try again later.',
    moreInfo: 'https://www.twilio.com/docs/errors/60005',
  },
  63019: {
    code: 63019,
    message: 'The media failed to upload. Please try again later.',
    moreInfo: 'https://www.twilio.com/docs/errors/63019',
  },
  0: {
    code: 0,
    message:
      'Unknown error, this is not a valid error code.  Something went wrong.',
    moreInfo: '',
  },
};

export const twilioVoiceErrorMap: TwilioErrors = {
  30003: {
    code: 30003,
    message:
      'The device you are trying to reach is switched off or out of coverage range.',
    moreInfo: 'https://www.twilio.com/docs/errors/30003',
  },
  30005: {
    code: 30005,
    message:
      'The destination you are trying to reach is unknown and may no longer exist.',
    moreInfo: 'https://www.twilio.com/docs/errors/30005',
  },
  13224: {
    code: 13224,
    message:
      'Our phone carrier does not support the number you are trying to reach, or the number is invalid.',
    moreInfo: 'https://www.twilio.com/docs/errors/13224',
  },
  15003: {
    code: 15003,
    message:
      'There was a problem with our application server. Please try again later. If the problem persists, please contact support.',
    moreInfo: 'https://www.twilio.com/docs/errors/15003',
  },
};
